// Demo 1: Spa Hotel Direct Booking
// Fictional brand: "Thermana Negorci Spa Hotel"
// Target: Gevgelija-area spa hotels + pensions paying 15% to Booking.com
// Pitch: direct booking = save 15% per reservation

import { useState } from 'react'
import DemoLayout from './shared/DemoLayout'
import { useT } from './shared/i18n-ctx'
import type { Dict } from './shared/i18n-ctx'

const dict: Dict = {
  hero_tag: {
    en: 'Direct booking · No commission · Save 15%',
    mk: 'Директна резервација · Без провизија · Заштедете 15%',
    gr: 'Απευθείας κράτηση · Χωρίς προμήθεια · Εξοικονομήστε 15%',
  },
  hero_title: {
    en: 'Demo · Spa Hotel',
    mk: 'Демо · Спа хотел',
    gr: 'Demo · Ξενοδοχείο spa',
  },
  hero_sub: {
    en: 'Thermal waters from 42°C natural springs. Wellness weekends. Family packages. Book direct and save.',
    mk: 'Термални води од 42°C природни извори. Велнес викенди. Семејни пакети. Резервирајте директно и заштедете.',
    gr: 'Θερμικά νερά από 42°C φυσικές πηγές. Wellness σαββατοκύριακα. Οικογενειακά πακέτα. Κλείστε απευθείας και κερδίστε.',
  },
  book_now: { en: 'Check availability', mk: 'Провери достапност', gr: 'Ελέγξτε διαθεσιμότητα' },
  rooms: { en: 'Rooms & suites', mk: 'Соби и апартмани', gr: 'Δωμάτια & σουίτες' },
  packages: { en: 'Spa packages', mk: 'Спа пакети', gr: 'Πακέτα σπα' },
  checkin: { en: 'Check-in', mk: 'Пристигнување', gr: 'Άφιξη' },
  checkout: { en: 'Check-out', mk: 'Заминување', gr: 'Αναχώρηση' },
  guests: { en: 'Guests', mk: 'Гости', gr: 'Επισκέπτες' },
  search: { en: 'Search rooms', mk: 'Пребарај соби', gr: 'Αναζήτηση δωματίων' },
  amenities: { en: 'What makes us special', mk: 'Што не прави посебни', gr: 'Τι μας κάνει ξεχωριστούς' },
  amen_1: { en: '4 thermal pools (indoor + outdoor)', mk: '4 термални базени (внатрешни + надворешни)', gr: '4 θερμικές πισίνες (εσωτερικές + εξωτερικές)' },
  amen_2: { en: 'Full-service spa — massages, wraps, facials', mk: 'Спа центар — масажи, тераписки третмани, лице', gr: 'Spa — μασάζ, θεραπείες, περιποίηση προσώπου' },
  amen_3: { en: 'Restaurant with regional Macedonian cuisine', mk: 'Ресторан со македонска регионална кујна', gr: 'Εστιατόριο με μακεδονική τοπική κουζίνα' },
  amen_4: { en: 'Kids pool + playroom (family friendly)', mk: 'Детски базен + игротека', gr: 'Παιδική πισίνα + αίθουσα παιχνιδιών' },
  amen_5: { en: '70 km from Thessaloniki · 160 km from Skopje', mk: '70 км од Солун · 160 км од Скопје', gr: '70 χλμ από Θεσσαλονίκη · 160 χλμ από Σκόπια' },
  amen_6: { en: 'Free parking + EV chargers', mk: 'Бесплатен паркинг + електрични полначи', gr: 'Δωρεάν πάρκινγκ + φορτιστές EV' },
  pkg_weekend_name: { en: 'Wellness Weekend', mk: 'Велнес викенд', gr: 'Σαββατοκύριακο wellness' },
  pkg_weekend_desc: {
    en: '2 nights, half-board, 60-min couples massage, unlimited spa.',
    mk: '2 ноќи, полупансион, 60-мин масажа за двајца, неограничен спа.',
    gr: '2 διανυκτερεύσεις, ημιδιατροφή, 60-λεπτο μασάζ για ζευγάρια, απεριόριστο spa.',
  },
  pkg_family_name: { en: 'Family Retreat', mk: 'Семеен одмор', gr: 'Οικογενειακή απόδραση' },
  pkg_family_desc: {
    en: '3 nights, 2 adults + 2 kids, all meals, kids program.',
    mk: '3 ноќи, 2 возрасни + 2 деца, сите оброци, детска програма.',
    gr: '3 διανυκτερεύσεις, 2 ενήλικες + 2 παιδιά, όλα τα γεύματα, παιδικό πρόγραμμα.',
  },
  pkg_detox_name: { en: 'Detox Week', mk: 'Детокс недела', gr: 'Εβδομάδα αποτοξίνωσης' },
  pkg_detox_desc: {
    en: '7 nights, nutritionist plan, daily yoga, 5 body treatments.',
    mk: '7 ноќи, план од нутриционист, дневна јога, 5 третмани за тело.',
    gr: '7 διανυκτερεύσεις, πλάνο διατροφολόγου, καθημερινή γιόγκα, 5 θεραπείες σώματος.',
  },
  per_person: { en: 'per person', mk: 'по лице', gr: 'ανά άτομο' },
  select: { en: 'Select', mk: 'Избери', gr: 'Επιλογή' },
  no_fees: { en: 'Lower than Booking.com', mk: 'Пониско од Booking.com', gr: 'Φθηνότερα από Booking.com' },
  found: { en: 'Available rooms', mk: 'Достапни соби', gr: 'Διαθέσιμα δωμάτια' },
  reserve: { en: 'Reserve', mk: 'Резервирај', gr: 'Κράτηση' },
  submitted: { en: '✓ Reservation request sent. The hotel will call you within 1 hour.', mk: '✓ Барањето е испратено. Хотелот ќе ве јави за еден час.', gr: '✓ Η αίτηση εστάλη. Το ξενοδοχείο θα καλέσει εντός 1 ώρας.' },
}

type Room = { id: string; name: Record<'en' | 'mk' | 'gr', string>; price: number; size: string }

const ROOMS: Room[] = [
  { id: 'std', name: { en: 'Standard Double', mk: 'Стандардна двокреветна', gr: 'Standard Δίκλινο' }, price: 65, size: '22 m²' },
  { id: 'sup', name: { en: 'Superior with balcony', mk: 'Супериор со балкон', gr: 'Superior με μπαλκόνι' }, price: 85, size: '28 m²' },
  { id: 'ste', name: { en: 'Thermal Suite', mk: 'Термален апартман', gr: 'Θερμική σουίτα' }, price: 140, size: '45 m²' },
]

const PACKAGES = [
  { key: 'weekend', price: 149 },
  { key: 'family', price: 289 },
  { key: 'detox', price: 690 },
] as const

export default function SpaHotelDemo() {
  return (
    <DemoLayout
      dict={dict}
      chatPersona={{
        name: 'Spa & Wellness Hotel',
        kind: 'booking',
        items: [
          { name: 'Spa day pass', price: 40 },
          { name: 'Full-body massage', price: 55 },
          { name: 'Facial treatment', price: 45 },
          { name: 'Sauna + pool access', price: 25 },
          { name: 'Couples package', price: 120 },
        ],
      }}
    >
      <Body />
    </DemoLayout>
  )
}

function Body() {
  const { t, lang } = useT()
  const [checkin, setCheckin] = useState('')
  const [checkout, setCheckout] = useState('')
  const [guests, setGuests] = useState(2)
  const [results, setResults] = useState<Room[] | null>(null)
  const [reserved, setReserved] = useState(false)

  function search() {
    setReserved(false)
    setResults(ROOMS)
  }
  function reserve() {
    setReserved(true)
  }

  return (
    <div className="bg-gradient-to-b from-ink-950 via-ink-950 to-ink-900">
      {/* Hero */}
      <section className="relative">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            backgroundImage:
              'url(https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=1600&q=70)',
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-32">
          <span className="chip bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 mb-5">
            💧 {t('hero_tag')}
          </span>
          <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight text-white max-w-3xl">
            {t('hero_title')}
          </h1>
          <p className="mt-5 text-lg text-ink-100 max-w-2xl">{t('hero_sub')}</p>

          {/* Booking bar */}
          <div className="mt-10 bg-ink-900/90 backdrop-blur border border-ink-800 rounded-2xl p-4 max-w-3xl">
            <div className="grid sm:grid-cols-4 gap-3">
              <label className="block">
                <span className="label">{t('checkin')}</span>
                <input type="date" className="input" value={checkin} onChange={(e) => setCheckin(e.target.value)} />
              </label>
              <label className="block">
                <span className="label">{t('checkout')}</span>
                <input type="date" className="input" value={checkout} onChange={(e) => setCheckout(e.target.value)} />
              </label>
              <label className="block">
                <span className="label">{t('guests')}</span>
                <input type="number" min={1} max={6} className="input" value={guests} onChange={(e) => setGuests(+e.target.value || 1)} />
              </label>
              <div className="flex items-end">
                <button onClick={search} className="btn-primary w-full">{t('search')}</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Search results */}
      {results && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <h2 className="text-2xl font-bold text-white mb-5">{t('found')}</h2>
          <div className="grid gap-4 md:grid-cols-3">
            {results.map((r) => (
              <div key={r.id} className="card">
                <h3 className="font-semibold text-white text-lg">{r.name[lang]}</h3>
                <p className="text-ink-500 text-sm">{r.size}</p>
                <div className="mt-3 text-3xl font-bold text-white">€{r.price}<span className="text-sm text-ink-500 font-normal"> / night</span></div>
                <div className="chip bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 mt-2">
                  {t('no_fees')}
                </div>
                <button onClick={reserve} className="btn-primary w-full mt-4">{t('reserve')}</button>
              </div>
            ))}
          </div>
          {reserved && (
            <div className="mt-6 rounded-xl bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 p-4 text-center font-medium">
              {t('submitted')}
            </div>
          )}
        </section>
      )}

      {/* Amenities */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-bold text-white mb-8">{t('amenities')}</h2>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {['amen_1', 'amen_2', 'amen_3', 'amen_4', 'amen_5', 'amen_6'].map((k) => (
            <div key={k} className="card flex gap-3 items-start">
              <span className="text-2xl">✓</span>
              <span className="text-ink-100">{t(k)}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Packages */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 pb-24">
        <h2 className="text-3xl font-bold text-white mb-8">{t('packages')}</h2>
        <div className="grid gap-4 md:grid-cols-3">
          {PACKAGES.map(({ key, price }) => (
            <div key={key} className="card">
              <h3 className="font-semibold text-white text-lg">{t(`pkg_${key}_name`)}</h3>
              <p className="text-ink-500 text-sm mt-2">{t(`pkg_${key}_desc`)}</p>
              <div className="mt-4 text-3xl font-bold text-white">
                €{price}
                <span className="text-sm text-ink-500 font-normal"> {t('per_person')}</span>
              </div>
              <button onClick={reserve} className="btn-primary w-full mt-4">{t('select')}</button>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
